<template>
  <v-sheet elevation="0" width="100%" style="margin-bottom: 1px; background-color: #CFD8DC;">
    <v-toolbar
      dark
      dense
      elevation="0"
    >
      <v-toolbar-title>
        <div>
          <div>{{serialNumber}}</div>
          <div style="font-size: 12px; font-weight: normal"><i>{{decodedSerialNumber}}</i></div>
        </div>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon>
        <v-badge
          v-model="showBadge"
          overlap
          color="amber"
        >
          <template
            v-slot:badge
          >
            <span>{{openSupportTickets}}</span>
          </template>
          <v-icon>bug_report</v-icon>
        </v-badge>
      </v-btn>
      <v-btn icon @click="removeFavorite()">
        <v-icon>{{favorite ? 'favorite' : 'favorite_border'}}</v-icon>
      </v-btn>
    </v-toolbar>
    <v-row>
      <v-col class="pl-5">
        <div>Software Version:</div>
        <div>Software Download:</div>
        <!--
        <div>Specs Version:</div>
        <div>Specs Expiration:</div>
        -->
        <div>Connection Count:</div>
        <div>Connected:</div>
        <div>Port:</div>
        <div>Address:</div>
        <div>Current Procedure:</div>
      </v-col>
      <v-col style="font-weight: bold;">
        <div v-if="version" :style="versionStyle">{{version}}</div>
        <div>{{pendingDownload || 'None'}}</div>
        <!--
        <div v-if="specs">{{`${specs.name} ${specs.month}/${specs.year}`}}</div>
        <div v-else>unknown</div>
        <div v-if="specsExpiration">{{`${specsExpiration.month}/${specsExpiration.year}`}}</div>
        <div v-else>unknown</div>
        -->
        <div>{{connectionCount}}</div>
        <div>{{connected ? 'Yes' : 'No'}}</div>
        <div v-if="connected">
          <div>{{getPort}}</div>
          <div>{{address ? address.split(',')[0].slice(7) : ' '}}</div>
          <div>{{currentProcedure || ' '}}</div>
        </div>
        <div v-else>
          <div><i>disconnected</i></div>
          <div><i>disconnected</i></div>
          <div><i>disconnected</i></div>
        </div>
      </v-col>
      <v-col>
        <div>Continent:</div>
        <div>Country:</div>
        <div>Region:</div>
        <div>City:</div>
        <div>Time Zone Name:</div>
        <div>Time Zone Offset:</div>
      </v-col>
      <v-col style="font-weight: bold;">
        <div>{{geolocation ? geolocation.continent_name : ''}}</div>
        <div>{{geolocation ? geolocation.country_name : ''}}</div>
        <div>{{geolocation ? geolocation.region : ''}}</div>
        <div>{{geolocation ? geolocation.city : ''}}</div>
        <div>{{geolocation ? geolocation.time_zone.name : ''}}</div>
        <div>{{geolocation ? geolocation.time_zone.offset : ''}}</div>
      </v-col>
      <v-col class="pr-5">
        <v-card v-if="canShowUpdateStatus" height="300">
          <v-card-title style="font-size: 12px; background-color: #ffc107; padding: 3px !important;">
            System Update Status
          </v-card-title>

          <!-- update state information -->
          <div class="pa-3">
            <div>{{updaterState}}</div>

            <div v-if="isDownloading">
              <div v-if="updateState.downloading.software">
                <div>Downloading software</div>
                <div>{{updateState.downloadProgress.software.currentFile}}</div>
                <div>{{updateState.downloadProgress.software.filesTransferred}}/{{updateState.downloadProgress.software.totalFilesToTransfer}}</div>
                <div>{{updateState.downloadProgress.software.fileProgress.bytesTransferred}}</div>
                <div>{{updateState.downloadProgress.software.fileProgress.progress}}%</div>
                <div>{{updateState.downloadProgress.software.fileProgress.transferRate}}</div>
                <div>{{updateState.downloadProgress.software.fileProgress.estimatedTimeRemaining}}</div>
              </div>
              <div v-else-if="updateState.downloading.specs">
                <div>Downloading specs</div>
                <div>{{updateState.downloadProgress.specs.currentFile}}</div>
                <div>{{updateState.downloadProgress.specs.filesTransferred}}/{{updateState.downloadProgress.specs.totalFilesToTransfer}}</div>
                <div>{{updateState.downloadProgress.specs.fileProgress.bytesTransferred}}</div>
                <div>{{updateState.downloadProgress.specs.fileProgress.progress}}%</div>
                <div>{{updateState.downloadProgress.specs.fileProgress.transferRate}}</div>
                <div>{{updateState.downloadProgress.specs.fileProgress.estimatedTimeRemaining}}</div>
              </div>
              <div v-else>

              </div>
            </div>

            <div v-if="isInstalling">
              <div v-if="updateState.installing.software">
                <div>Installing software</div>
                <div>{{updateState.installProgress.software}}</div>
              </div>
              <div v-else-if="updateState.installing.specs">
                <div>Installing specs</div>
                <div>{{updateState.installProgress.specs}}</div>
              </div>
              <div v-else>

              </div>
            </div>

          </div>
          <!-- END update state information -->

          <div style="position: absolute; bottom: 0; width: 100%; text-align: right;">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="black" text icon x-small @click="onCheckNow()" v-on="on" ><v-icon x-small>cloud</v-icon></v-btn>
              </template>
              <span>Check Cloud</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="black" text icon x-small @click="onDownload()" v-on="on"><v-icon x-small>arrow_downward</v-btn>
              </template>
              <span>Download Updates</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="black" text icon x-small @click="onInstall()" v-on="on"><v-icon x-small>system_update_alt</v-icon></v-btn>
              </template>
              <span>Install Updates</span>
            </v-tooltip>

          </div>
        </v-card>
        <!--
        <v-card v-else class="pa-3">
          <div>Aligner must be at version 4.3.0 or greater to display update state information.</div>
        </v-card>
        -->
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import semver from 'semver';
import decodeSerialNumber from '../../decodeSerialNumber';

export default {
  computed: {
    isDownloading() {
      if (this.updateState && this.updateState.state === 'DOWNLOADING') {
        return true;
      }

      return false;
    },

    isInstalling() {
      if (this.updateState && this.updateState.state === 'INSTALLING_UPDATE') {
        return true;
      }

      return false;
    },

    updaterState() {
      let result = '';

      if (this.updateState) {
        switch (this.updateState.state) {
          case 'BUSY':
            result = 'Busy';
            break;
          case 'TRY_INSERT_DIFFERENT_UPDATE':
          case 'TRY_INSERT_UPDATE':
            result = 'Nothing Pending';
            break;
          case 'READY_TO_DOWNLOAD':
            result = 'Pending Download';
            break;
          case 'DOWNLOADING':
            result = 'Downloading';
            break;
          case 'READY_TO_INSTALL':
            result = 'Install Pending';
            break;
          case 'VALIDATING_UPDATE':
            result = 'Validating Update Contents';
            break;
          case 'SYSMAN_RESTART':
            result = 'Restarting Updater';
            break;
          case 'INSTALLING_UPDATE':
            result = 'Installing';
            break;
          case 'INSTALLATION_COMPLETE':
            result = 'Install Complete';
            break;
          default:
            result = this.updateState.state;
            break;
        }
      }

      return result;
    },

    decodedSerialNumber() {
      if (this.serialNumber) {
        const decodedSerialNumber = decodeSerialNumber(this.serialNumber.toUpperCase());
        if (decodedSerialNumber) {
          return `${decodedSerialNumber.marketingName} ${decodedSerialNumber.buildMonth}/${decodedSerialNumber.buildYear}`;
        }
      }

      return '...';
    },

    getPort() {
      return this.port;
    },

    showBadge() {
      return this.openSupportTickets > 0;
    },

    versionStyle() {
      let style = 'color:green;';

      if (this.family === 'gtps') {
        if (semver.gt(this.$store.state.latestGtpsSoftwareVersion.semantic, this.version)) {
          style = 'color:red;';
        }
      } else if (semver.gt(this.$store.state.latestSoftwareVersion.semantic, this.version)) {
        style = 'color:red;';
      }

      return style;
    },

    canShowUpdateStatus() {
      if (this.family === 'gtps') {
        return semver.gte(this.version, '1.0.0');
      } else {
        return semver.gte(this.version, '4.3.0');
      }
    },
  },

  props: {
    serialNumber: String,
    version: String,
    pendingDownload: String,
    specs: Object,
    specsExpiration: Object,
    connected: Boolean,
    favorite: Boolean,
    openSupportTickets: Number,
    port: String,
    address: String,
    connectionCount: Number,
    currentProcedure: String,
    alignmentCount: Number,
    geolocation: Object,
    updateState: Object,
    family: String,
  },

  methods: {
    removeFavorite() {
      this.$emit('onRemoveFavorite', this.serialNumber);
    },

    onCheckNow() {
      const options = {
        method: 'post',
        url: '/cmd/aligner_check_now/v1',
        data: {
          serialNumber: this.serialNumber,
        },
      };

      this.axios(options);
    },

    onDownload() {
      const options = {
        method: 'post',
        url: '/cmd/aligner_download_now/v1',
        data: {
          serialNumber: this.serialNumber,
        },
      };

      this.axios(options);
    },

    onInstall() {
      const options = {
        method: 'post',
        url: '/cmd/aligner_install_now/v1',
        data: {
          serialNumber: this.serialNumber,
        },
      };

      this.axios(options);
    },
  },
};
</script>
